export default __webpack_public_path__ + "static/media/raki_detail13.6c3a76c7.jpg";